import React from 'react';
import { Link } from 'react-router-dom';
import {
  getAnalyticsConsent,
  initializeGaAfterConsent,
  isGaConfigured,
  setAnalyticsConsent,
} from '../utils/analytics';

const panelStyle = {
  background: '#071522',
  border: '1px solid rgba(96, 165, 250, 0.45)',
  borderRadius: 14,
  color: '#e2e8f0',
  padding: '1rem',
  boxShadow: '0 12px 32px rgba(0, 0, 0, 0.35)',
};

export function AnalyticsPrivacyControls() {
  const [consent, setConsent] = React.useState(getAnalyticsConsent());
  const configured = isGaConfigured();

  React.useEffect(() => {
    const onConsentChange = (event) => setConsent(event.detail?.consent || getAnalyticsConsent());
    window.addEventListener('squadverse:analytics-consent', onConsentChange);
    return () => window.removeEventListener('squadverse:analytics-consent', onConsentChange);
  }, []);

  const choose = (nextConsent) => {
    setAnalyticsConsent(nextConsent);
    setConsent(nextConsent);
  };

  if (!configured) {
    return <p style={{ color: '#64748b', lineHeight: 1.6 }}>Analytics is not configured on this deployment.</p>;
  }

  return (
    <section style={panelStyle} aria-labelledby="analytics-preferences-heading">
      <h2 id="analytics-preferences-heading" style={{ marginTop: 0, color: '#fff' }}>Analytics preferences</h2>
      <p style={{ lineHeight: 1.6 }}>
        Optional GA4 product analytics helps us understand game starts, results and successful shares. It never includes player names, squads, searches or hidden ratings.
      </p>
      <p style={{ color: '#b6c7db', fontSize: '0.9rem' }}>
        Current choice: <strong>{consent === 'granted' ? 'analytics accepted' : consent === 'denied' ? 'analytics rejected' : 'not chosen'}</strong>
      </p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
        <button type="button" className="sv-btn sv-btn--primary" onClick={() => choose('granted')}>Allow analytics</button>
        <button type="button" className="sv-btn sv-btn--ghost" onClick={() => choose('denied')}>Reject analytics</button>
      </div>
    </section>
  );
}

export default function AnalyticsConsent() {
  const [consent, setConsent] = React.useState(getAnalyticsConsent());
  const configured = isGaConfigured();

  React.useEffect(() => {
    if (consent === 'granted') initializeGaAfterConsent();
  }, [consent]);

  if (!configured || consent !== 'unknown') return null;

  const choose = (nextConsent) => {
    setAnalyticsConsent(nextConsent);
    setConsent(nextConsent);
  };

  return (
    <aside
      role="dialog"
      aria-label="Optional analytics preference"
      style={{ ...panelStyle, position: 'fixed', right: 12, bottom: 12, zIndex: 1000, maxWidth: 430 }}
    >
      <strong style={{ color: '#fff' }}>Optional analytics</strong>
      <p style={{ margin: '0.5rem 0', lineHeight: 1.5, fontSize: '0.9rem' }}>
        Help improve Squadverse with limited game events. They do not include names, squads or hidden ratings. You can change this choice any time in our <Link to="/privacy" style={{ color: '#7dd3fc' }}>Privacy Policy</Link>.
      </p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
        <button type="button" className="sv-btn sv-btn--primary" onClick={() => choose('granted')}>Accept analytics</button>
        <button type="button" className="sv-btn sv-btn--ghost" onClick={() => choose('denied')}>Reject</button>
      </div>
    </aside>
  );
}
